import moment from "moment";

export const displayDate = ({ date, format, empty }) => {
  const defaultFormat = format || "DD/MM/YYYY";
  const defaultEmpty = empty === null || empty === undefined ? "-" : empty;
  if (!date) return defaultEmpty;
  return moment(date).format(defaultFormat);
};

export const getDateWithoutTimezone = string => {
  // string: YYYY-MM-DDTHH:mm:ss.---Z | 2024-11-18T07:50:44.538Z
  if (!string) return "";
  const base = string.split("T");
  const date = base[0]; // YYYY-MM-DD
  // const time = base[1].split(".")[0]; // HH:mm:ss
  // return DD/MM/YYYY
  return date
    .split("-")
    .reverse()
    .join("/");
};

// currency_settings: {
//   id: "idr",
//   alternate_symbols: [],
//   decimal_mark: ",",
//   disambiguate_symbol: null,
//   html_entity: "",
//   iso_code: "IDR",
//   iso_numeric: "360",
//   name: "Indonesian Rupiah",
//   priority: 100,
//   smallest_denomination: 5000,
//   subunit: "Sen",
//   subunit_to_unit: 100,
//   symbol: "Rp",
//   symbol_first: true,
//   thousands_separator: ".",
//   format: null
// };
export const displayPrice = ({ settings, price }) => {
  if (price === null || price === undefined) return 0;
  const { thousands_separator: sparator } = settings;

  // const defaultCurrency = currency || "IDR";
  // const noComma = ["IDR", "VND"];
  // const comma = noComma.includes(defaultCurrency) ? 0 : 2;
  const comma = sparator === "." ? 0 : 2;

  const formated = Math.abs(price)
    .toFixed(comma)
    .replace(/\B(?=(\d{3})+(?!\d))/g, sparator);

  const negative = price < 0;
  return negative ? `(${formated})` : formated;
};



// WEBPACK FOOTER //
// ./src/plugins/helper.js